import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';

const Hero = () => {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();

  return (
    <section className="py-10 px-4 sm:px-6 xl:px-8 bg-[#EDEDED] h-[670px] md:h-[850px] flex items-center justify-center">
      <div className="max-w-[1300px] w-full text-center flex flex-col items-center justify-center">
        <div className="max-w-[1440px] lg:block hidden w-full mx-auto mb-7">
          <img
            src="/assets/paint-page.webp"
            alt="Paint tin"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="max-w-[1440px] md:hidden block w-full mx-auto mb-7">
          <img
            src="/assets/mobile-paint.webp"
            alt="Paint tin"
            className="w-full h-full object-contain"
          />
        </div>

        <h1 className="libre-baskerville font-normal text-[32px] sm:text-[60px] lg:text-[94px] leading-[40px] sm:leading-[70px] lg:leading-[110px] text-[#000000] mb-4 md:mb-6">
          {t('categories.Mastics / Putties')}
        </h1>

        <p className="text-[#1D1D1F] text-[14px] sm:text-[16px] leading-[19px] mb-4 md:mb-6 max-w-[1152px] inter font-normal">
          {' '}
          Product based on modified alkyd resins, featuring extremely fast
          drying, good adhesion and easy sanding. Made up of fine grain paste,
          it is particularly suitable for retouch of small defects, pin holes,
          porosity and light scratches. After sanding with very fine paper it
          can be directly over-coated with finishing enamels.
        </p>

        <Link
          to={getLocalizedPath('/product')}
          className="border border-[#000000] rounded-[9px] h-[40px] text-[#000000] text-[12px] leading-[20px] font-medium flex items-center justify-center pr-2 pl-4 w-fit"
        >
          Go To Product
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.3281 9C15.5156 9 15.6771 9.0625 15.8125 9.1875L20.4688 13.8594C20.6042 13.9844 20.6719 14.1406 20.6719 14.3281C20.6719 14.5156 20.6042 14.6771 20.4688 14.8125L15.8125 19.4688C15.6771 19.6042 15.5156 19.6719 15.3281 19.6719C15.1406 19.6719 14.9844 19.6042 14.8594 19.4688C14.7344 19.3438 14.6719 19.1875 14.6719 19C14.6719 18.8125 14.7344 18.6562 14.8594 18.5312L18.3906 15H8C7.8125 15 7.65625 14.9323 7.53125 14.7969C7.39583 14.6719 7.32812 14.5156 7.32812 14.3281C7.32812 14.151 7.39583 13.9948 7.53125 13.8594C7.65625 13.7344 7.8125 13.6719 8 13.6719H18.3906L14.8594 10.1406C14.7344 10.0156 14.6719 9.85938 14.6719 9.67188C14.6719 9.47396 14.7344 9.3125 14.8594 9.1875C14.9844 9.0625 15.1406 9 15.3281 9Z"
              fill="black"
            />
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default Hero;
